import React, { Component } from 'react';
import {Redirect} from 'react-router-dom';

class Login extends Component {
  constructor() {
    super();
    this.state = {
      usr: "",
      pass: "",
      alert: "",
      msg: false
    }
  }
  loginAttempt = () => {
    let usr = this.state.usr,
        pass = this.state.pass,
        lang = this.props.lang,
        alert = this.props.langtxt.login;
    if (usr.length < 4) {
      this.setState({alert: alert.al_user[lang], msg: true});
    } else if (pass.length < 4) {
      this.setState({alert: alert.al_pass[lang], msg: true});
    } else {
      this.props.login(usr, pass);
    }
  }
  getInput = (state) => (event) => {
    this.setState({[state]: event.target.value})
  }
  render() {
    let label = this.props.langtxt.login;
    let lang = this.props.lang;
    return (
      <div id="Login">
        {
          this.props.loged
          ? <Redirect to="/home/tableros" push={true}/>
          : null
        }
        <div id="Logo-login">
        </div>
        <form>
          <label>{label.usuario[lang]}</label>
          <input type="text" id="usr" placeholder={label.usuario[lang]} onChange={this.getInput("usr")} autoComplete="on"/>
          <label>{label.pass[lang]}</label>
          <input type="password" id="usrID" placeholder={label.pass[lang]} onChange={this.getInput("pass")} autoComplete="on"/>
          {
           this.state.msg 
           ?<span>{this.state.alert}</span>
           : null
          }
        </form>
        <button className="outlined-button" onClick={() => this.loginAttempt()}>Login</button>
      </div>
    );
  }
}

export default Login;


// WEBPACK FOOTER //
// ./src/Components/Login/Login.js